import { render, staticRenderFns } from "./TemplateCategories.vue?vue&type=template&id=760abdff&"
import script from "./TemplateCategories.vue?vue&type=script&lang=js&"
export * from "./TemplateCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('760abdff')) {
      api.createRecord('760abdff', component.options)
    } else {
      api.reload('760abdff', component.options)
    }
    module.hot.accept("./TemplateCategories.vue?vue&type=template&id=760abdff&", function () {
      api.rerender('760abdff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/whatsapp/template/component/TemplateCategories.vue"
export default component.exports